var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-taglist-base section basic-section"},[_vm._m(0),_vm._v(" "),_c('tag-list',{attrs:{"tag-list":_vm.hotTaglist,"link-enable":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-icon"},[_c('img',{attrs:{"src":"/static/img/icons/ic_tag.svg"}})])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b15e308","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/Toppage/section/HotTagList.vue
// module id = null
// module chunks = 